var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseInCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 8C13.125 11.1066 10.6066 13.625 7.5 13.625C4.3934 13.625 1.875 11.1066 1.875 8C1.875 4.8934 4.3934 2.375 7.5 2.375C10.6066 2.375 13.125 4.8934 13.125 8ZM5.18306 10.3169C4.93898 10.0729 4.93898 9.67714 5.18306 9.43306L6.61612 8L5.18306 6.56694C4.93898 6.32286 4.93898 5.92714 5.18306 5.68306C5.42714 5.43898 5.82286 5.43898 6.06694 5.68306L7.5 7.11612L8.93306 5.68306C9.17714 5.43898 9.57286 5.43898 9.81694 5.68306C10.061 5.92714 10.061 6.32286 9.81694 6.56694L8.38388 8L9.81694 9.43306C10.061 9.67714 10.061 10.0729 9.81694 10.3169C9.57286 10.561 9.17714 10.561 8.93306 10.3169L7.5 8.88388L6.06694 10.3169C5.82286 10.561 5.42714 10.561 5.18306 10.3169Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseInCircle);
export default __webpack_public_path__ + "static/media/CloseInCircle.ae42526c.svg";
export { ForwardRef as ReactComponent };